import React, { useEffect, createElement } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import LogoSection from './components/LogoSection';
import StatsSection from './components/StatsSection';
import TaleOfTwoOwnersSection from './components/TaleOfTwoOwnersSection';
import TeamSection from './components/TeamSection';
import TimelineSection from './components/TimelineSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import ThankYouPage from './pages/ThankYouPage';
import HealthcareClinicsPage from './pages/HealthcareClinicsPage';
import BookingPage from './pages/BookingPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
// Home page component
const HomePage = () => <>
    <HeroSection data-id="element-0" />
    <LogoSection data-id="element-1" />
    <StatsSection data-id="element-2" />
    <TaleOfTwoOwnersSection data-id="element-3" />
    <TeamSection data-id="element-4" />
    <TimelineSection data-id="element-5" />
    <FAQSection data-id="element-6" />
  </>;
export function App() {
  return <HelmetProvider data-id="element-7">
      <BrowserRouter data-id="element-8">
        <div className="flex flex-col min-h-screen bg-white" data-id="element-9">
          <Helmet data-id="element-10">
            <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-11" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-12" />
            <link href="https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400..800;1,400..800&family=Libre+Caslon+Text:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet" data-id="element-13" />
            <script src="https://fast.wistia.com/player.js" async data-id="element-14"></script>
            <script src="https://fast.wistia.com/embed/9ccnfz42p2.js" async type="module" data-id="element-15"></script>
            <style data-id="element-16">{`
              @import url("https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400..800;1,400..800&family=Libre+Caslon+Text:ital,wght@0,400;0,700;1,400&display=swap");
              h1, h2, h3, h4, h5, h6 {
                font-family: "EB Garamond", serif !important;
                font-optical-sizing: auto !important;
                font-weight: 600 !important;
                font-style: normal !important;
              }
              wistia-player[media-id='9ccnfz42p2']:not(:defined) { 
                background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/9ccnfz42p2/swatch'); 
                display: block; 
                filter: blur(5px); 
                padding-top:56.25%; 
              }
            `}</style>
          </Helmet>
          <Routes data-id="element-17">
            <Route path="/" element={<main className="flex-grow" data-id="element-19">
                  <HomePage data-id="element-20" />
                </main>} data-id="element-18" />
            <Route path="/thankyoupage" element={<ThankYouPage data-id="element-22" />} data-id="element-21" />
            <Route path="/healthcareclinics" element={<HealthcareClinicsPage data-id="element-24" />} data-id="element-23" />
            <Route path="/bookingpage" element={<BookingPage data-id="element-26" />} data-id="element-25" />
            <Route path="/privacypage" element={<PrivacyPage data-id="element-28" />} data-id="element-27" />
            <Route path="/termsofservice" element={<TermsOfServicePage data-id="element-30" />} data-id="element-29" />
          </Routes>
          <Routes data-id="element-31">
            <Route path="/" element={<Footer data-id="element-33" />} data-id="element-32" />
            <Route path="/healthcareclinics" element={<Footer data-id="element-35" />} data-id="element-34" />
            <Route path="/bookingpage" element={<Footer data-id="element-37" />} data-id="element-36" />
          </Routes>
        </div>
      </BrowserRouter>
    </HelmetProvider>;
}